import moment from 'moment-timezone';

export const DEFAULT_ALLOWED_PERIOD_IN_DAYS = 90;
export const LEGACY_ALLOWED_PERIOD_ATTRIBUTE = 'flex_office_max_advance_booking_days';

const parseAllowedPeriodInDays = (value) => {
    const parsedValue = parseInt(value, 10);
    return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
};

export const getAllowedPeriodInDays = (company = {}) => {
    const configurationValue = parseAllowedPeriodInDays(company?.configuration?.allowedPeriodInDays);
    if (configurationValue) {
        return configurationValue;
    }

    const legacyValue = parseAllowedPeriodInDays(
        (company?.dynamicAttributes || []).find(
            (attribute) => attribute?.name === LEGACY_ALLOWED_PERIOD_ATTRIBUTE
        )?.value
    );

    return legacyValue || DEFAULT_ALLOWED_PERIOD_IN_DAYS;
};

export const getMaxAllowedBookingDate = (company, timezone) =>
    moment().tz(timezone).startOf('day').add(getAllowedPeriodInDays(company), 'days');

export const isClosedDay = (dateMoment, company, timezone) => {
    const workingDays = company?.workingSchedule?.workingDays || [];
    const holidays = company?.workingSchedule?.holidays || [];

    if (workingDays.length > 0) {
        const dayName = dateMoment.format('dddd').toUpperCase();
        if (!workingDays.includes(dayName)) {
            return true;
        }
    }

    return holidays.some((holiday) => {
        const holidayDate = typeof holiday === 'string' ? holiday : holiday?.date;
        return holidayDate && dateMoment.isSame(moment.tz(holidayDate, timezone), 'day');
    });
};
